import React from 'react';
import { Grid } from '@mui/material';
import { Layout } from '@/containers';
import ItemRoute from '@/pageComponents/Items';

const Discounts = () => (
    <Layout>
        <Grid container direction="row">
            <Grid item xs={12}>
                <ItemRoute pathname="/items/discounts" />
            </Grid>
        </Grid>
    </Layout>
);

export default Discounts;
